<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("BUTTONS.view_notification_details") }}</h4>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <!-- Start:: Title Ar Input -->

              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleAr')"
                v-model.trim="data.titleAr"
                disabled
              />
              <!-- End:: Title Ar Input -->

              <!-- Start:: Title En Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleEn')"
                v-model.trim="data.titleEn"
                disabled
              />
              <!-- End:: Title En Input -->

              <!-- Start:: Content Ar Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentAr')"
                v-model.trim="data.contentAr"
                disabled
              />
              <!-- End:: Content Ar Input -->

              <!-- Start:: Content En Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentEn')"
                v-model.trim="data.contentEn"
                disabled
              />
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.send_date')"
                v-model.trim="data.date"
                disabled
              />

              <!-- Start:: Receiver Type Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.receiverType')"
                v-model.trim="data.receiverType_translated"
                disabled
              />
              <!-- End:: Receiver Type Input -->
              <!-- Start:: Users Data Display (All Cases) -->
              <base-select-input
                v-if="data.usersData && data.usersData.length"
                col="6"
                :optionsList="data.usersData"
                :placeholder="$t('PLACEHOLDERS.recievers')"
                v-model="data.usersData"
                disabled
                multiple
              />
              <!-- End:: Users Data Display -->
              <!-- End:: Content En Input -->
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateNotification",

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allClientsData: "ApiGetsModule/allClientsData",
      allDriversData: "ApiGetsModule/allDriversData",
    }),
    // End:: Vuex Getters

    receiverTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.service_seeker_singular"),
          value: "clients",
        },
        {
          id: 3,
          name: this.$t("PLACEHOLDERS.service_provider_singular"),
          value: "providers",
        },
        {
          id: 5,
          name: this.$t("PLACEHOLDERS.both"),
          value: "all",
        },
      ];
    },
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        receiverType: null,
        receiverType_translated: null,
        clients: [],
        vendors: [],
        stables: [],
        owners: [],
        client: [],
        vendor: [],
        stable: [],
        owner: [],
        usersData: [],
        titleAr: null,
        titleEn: null,
        contentAr: null,
        contentEn: null,
        date: null,
      },

      // End:: Data Collection To Send
    };
  },
  watch: {
    // 'data.clients'() {
    //   this.data.clients.forEach((value) => {
    //     if (value.id == '-1') {
    //       this.data.clients = this.allClientsData
    //       return;
    //     }
    //   })
    // },
    // 'data.drivers'() {
    //   this.data.drivers.forEach((value) => {
    //     if (value.id == '-1') {
    //       this.data.drivers = this.allDriversData
    //       return;
    //     }
    //   })
    // }
  },

  methods: {
    // End:: Vuex Actions

    async getClients() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `clients?page=0`,
        });

        this.data.clients = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getProviders() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `providers?page=0`,
        });
        this.data.providers = res.data.data.data?.map((ele) => ele.user);
      } catch (error) {
        console.log(error.response.data.message);
      }
    },

    async getNotificationData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `admin-notifications/${this.$route.params.id}`,
        });

        this.data.titleAr = res.data.data.AdminNotfication.title_ar;
        this.data.titleEn = res.data.data.AdminNotfication.title_en;
        this.data.contentAr = res.data.data.AdminNotfication.content_ar;
        this.data.contentEn = res.data.data.AdminNotfication.content_en;

        this.data.date = res.data.data.AdminNotfication?.created_at;

        const usersData = res.data.data.AdminNotfication?.users_data || [];
        console.log(usersData);
        this.data.usersData = usersData.map((user, i) => ({
          id: i,
          name: user,
          label: user,
          value: user,
        }));

        // console.log(this.data.usersData[0]);
        this.data.receiverType = res.data.data.AdminNotfication.recipient_type;
        this.data.receiverType_translated =
          res.data.data.AdminNotfication.recipient_type;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message), "sasdsd";
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    // Start:: Fire Methods
    this.getNotificationData();
    this.getClients();
    this.getProviders();
    // End:: Fire Methods
  },
};
</script>
